import styles from './ButtonText.module.scss'
import { FunctionComponent } from 'react'

interface ButtonTextProps {
    text: string
    onClick: () => void
    parent?: boolean
    fullWidth?: boolean
    className?: string
    disabled?: boolean
}

const ButtonText: FunctionComponent<ButtonTextProps> = ({
    text,
    onClick,
    parent = false,
    fullWidth,
    className,
    disabled = false
}: ButtonTextProps) => {
    return (
        <button
            className={`${styles.button} 
							${disabled ? styles.buttonDisabled : ''}
							${
                                parent
                                    ? disabled
                                        ? styles.buttonParentDisabled
                                        : styles.buttonParent
                                    : disabled
                                      ? styles.buttonDaycareDisabled
                                      : styles.buttonDaycare
                            }
							${fullWidth ? styles.buttonFullWidth : ''}
							${className}`}
            onClick={onClick}
            disabled={disabled}
        >
            <span>{text}</span>
        </button>
    )
}

export default ButtonText
